/**
 * `/stop-view-as` is the exit that works when nothing else does: a bookmark or typed URL that leaves the session
 * without calling the backend or rendering any page the target might be unable to load.
 */
import type React from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { clearViewAs } from 'src/lib/view-as/view-as-store';
import { rtkQueryBase } from 'src/store/rtk-query-base';

export const StopViewAsRoute: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    clearViewAs();
    dispatch(rtkQueryBase.util.resetApiState());
    navigate('/', { replace: true });
  }, [dispatch, navigate]);

  return null;
};
